<script setup lang="ts">
import { cn } from '../ui-utils.ts';
import { ComboboxInput, type ComboboxInputProps, useForwardProps } from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<
  ComboboxInputProps & {
    class?: HTMLAttributes['class'];
  }
>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <div class="flex items-center border-b px-3" cmdk-input-wrapper>
    <i class="fa-light fa-magnifying-glass mr-2 shrink-0 opacity-50"></i>
    <ComboboxInput
      v-bind="{ ...forwardedProps, ...$attrs }"
      autoFocus
      :class="
        cn(
          'flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-hidden placeholder:text-slate-500 disabled:cursor-not-allowed disabled:opacity-50',
          props.class,
        )
      "
    />
  </div>
</template>
